module.exports = __webpack_public_path__ + "img/enableExtendConfirmSetting_01.e033afe8.png";